export default "__VITE_ASSET__BSlCmvCZ__"